/**
 * Owner disbursements — step 13, ledger side only. See CLAUDE.md's "Owner
 * disbursements" section for what's built this pass versus deferred to the
 * later Stripe Connect adapter step.
 */
import { z } from 'zod';
import { OWNER_DISBURSEMENT_STATUSES, OWNER_STATEMENT_LINE_TYPES, } from '../enums.js';
import { dateOnlySchema, optionalText, text, uuidSchema } from './common.js';
export const ownerDisbursementStatusSchema = z.enum(OWNER_DISBURSEMENT_STATUSES);
export const ownerStatementLineTypeSchema = z.enum(OWNER_STATEMENT_LINE_TYPES);
export const ownerDisbursementPeriodQuerySchema = z.object({
    periodStart: dateOnlySchema,
    periodEnd: dateOnlySchema,
});
export const ownerDisbursementListQuerySchema = z.object({
    ownerId: uuidSchema.optional(),
    status: ownerDisbursementStatusSchema.optional(),
});
export const ownerStatementListQuerySchema = z.object({
    ownerId: uuidSchema.optional(),
});
/** Single owner, single period — there is deliberately no bulk shape here. */
export const approveOwnerDisbursementSchema = z.object({
    ownerId: uuidSchema,
    periodStart: dateOnlySchema,
    periodEnd: dateOnlySchema,
});
/**
 * This pass's only reachable "money moved" transition — a staff-recorded
 * check/wire reference, no Stripe call. See OwnerDisbursementStatus.
 */
export const settleOwnerDisbursementExternallySchema = z.object({
    referenceNumber: text(255),
    settledOn: dateOnlySchema,
    note: optionalText(2000),
});
//# sourceMappingURL=disbursements.js.map